import ConfidenceTile from './ConfidenceTile';

export default ConfidenceTile;
